import { SERVICE_TYPE, VENDOR_TYPE } from "./constants";
import http from "../utils/http";

// TODO 串好auth相關api後改用api版本的路由
export const log = ({ vendorType, serviceType, rawData }) =>  http.post('/speech-service-logs', {
    vendorType,
    serviceType,
    rawData: typeof rawData === 'string' ? rawData : JSON.stringify(rawData),
});

export const logMimiAsr = (rawData) => log({
    vendorType: VENDOR_TYPE.MIMI,
    serviceType: SERVICE_TYPE.ASR,
    rawData
});

export const logMimiTra = (rawData) => log({
    vendorType: VENDOR_TYPE.MIMI,
    serviceType: SERVICE_TYPE.TRA,
    rawData: JSON.stringify(rawData),
});

export const logAzureAsr = (rawData) => log({
    vendorType: VENDOR_TYPE.AZURE,
    serviceType: SERVICE_TYPE.ASR,
    rawData
});

export const logAzureTra = (rawData) => log({
    vendorType: VENDOR_TYPE.AZURE,
    serviceType: SERVICE_TYPE.TRA,
    rawData
});

export const logAzureLid = (rawData) => log({
    vendorType: VENDOR_TYPE.AZURE,
    serviceType: SERVICE_TYPE.LID,
    rawData
});
